import axios from '../../util/axios';
import '../../util/mock/zh/getParkBuildingInfo';
import {random, startAnim} from "../../util/util";
import Easing from "../../util/Easing";

import {
    setBlockNodeOpacity
} from '../../util/util';
import { runTableScrollAnim } from '../../util/Animation';
import { SUBSYSTEM_CAMERA } from '../../util/constant';

/**
 * 智慧楼宇
 */
export default class ParkBuilding {
    constructor(main) {
        this.main = main;
        this.g2d = main.g2d;
        this.dm = main.g2d.dm();
        this.open = false;
        this.htAnims = {};
        this.intervalAnims = {};
        this.firstEnterNight = true;
        this.currenSubsystemType = 'parkBuildingSubject';
        this.runSwitchSubsystem = false;
    }

    /**
     * 初始化 2D 面板上的数据
     */
    init() {
        axios.get('getParkBuildingInfo').then(res => {
            this.subjectDatas = res;
            
            const dm = this.dm;
            const bsL1 = dm.getDataByTag('BS_L_1');
            const bsL2 = dm.getDataByTag('BS_L_2');
            const bsR1 = dm.getDataByTag('BS_R_1');
            const bsR2 = dm.getDataByTag('BS_R_2');
            const bsR3 = dm.getDataByTag('BS_R_3');
            // 楼宇指标信息（右一）
            const parkIntroduction = dm.getDataByTag('parkIntroduction');
            parkIntroduction.a('ht.dataSource', res.introduction);
            bsL1.getChildAt(2).a(res.buildingIndex);
            // 人员出入统计（右二）
            const bsL2Series = bsL2.getChildAt(2).a('ht.series');
            const bsL2Names = res.peopleOutIn.name;
            bsL2Series[0].name = bsL2Names[0];
            bsL2Series[1].name = bsL2Names[1];
            bsL2.getChildAt(2).a({
                seriesData1: res.peopleOutIn.in,
                seriesData2: res.peopleOutIn.out,
                axisData: res.peopleOutIn.time
            });
            bsL2Series
            // 能耗分析（左一）(重置)
            bsR1.getChildAt(1).a({
                energyRatio: 0,
                totalEnergy: 0,
                totalLoad: 0,
                clipPercentage1: 0,
                clipPercentage2: 0,
                percentageValue: 0
            })
            // 实时人员（左二）
            const people = res.people;
            bsR2.getChildAt(1).a('totalPopulation', people.staff + people.security + people.visitor);
            bsR2.getChildAt(2).eachChild((node,i) => {
                const name = i === 0 ? 'staff' : i === 1 ? 'security' : 'visitor';
                node.a('value', people[name])
            });
            // 人流量分析（左三）
            bsR3.getChildAt(1).a(res.flowAnalysis);
            bsR3.getChildAt(2).a({
                seriesData1: res.flowYearAnalysis['2020'],
                seriesData2: res.flowYearAnalysis['2021'],
                axisData: res.flowYearAnalysis.time
            });
            setTimeout(() => {
                this.startMainPageAnim();
            },2000);

            // 子页面-照明系统
            const pageLight = res.pageLight;
            dm.getDataByTag('environmentWorkingTable').a('ht.dataSource',pageLight.environment);
            dm.getDataByTag('LS_R_1_linechart').a('axisData',pageLight.lighting);
            dm.getDataByTag('lightigRealAlarmTable').a('ht.dataSource',pageLight.alarm);
            
            // 子页面-消防系统
            const pageFire = res.pageFire;
            const highRiskFire = pageFire.highRiskFire; 
            console.log(highRiskFire);
            this.dm.getDataByTag('highRiskFireTable').a('ht.dataSource', highRiskFire);
        });
    }

    /**
     * 切换子系统
     * @param {*} name 
     */
    switchSubsystem(name, callback) {
        const dm = this.dm;
        const pageMap = this.main.pageMap;
        
        this.runSwitchSubsystem = true;
        pageMap.setHomeView();

        const parkBuildingSubject = dm.getDataByTag('parkBuildingSubject');
        const currentSubjectPanel = dm.getDataByTag(this.currenSubsystemType);

        this.resetAllPage();

        if(name) {
            // 按钮重置
            ['elevatorSystem', 'lightSystem', 'fireFightingSystem', 'securitySystem', 'airConditioningSystem'].forEach(tag => {
                const node = dm.getDataByTag(tag);
                if(node) {
                    node.s('state', tag === name ? '选中' : '默认');
                    node.a('active', tag === name);
                }
            });
            if(this.firstEnterNight) {
                this.firstEnterNight = false;
                pageMap.setHTDaySceneVisible(false);
                pageMap.setHTNightSceneVisible();
                pageMap.openNightSceneLight();
                pageMap.closeDaySceneLight();            
                // pageMap.switchDigitalTwinMode('night');
                // 开启车流
                pageMap.startCarFlowAnim();
                
                // 切换线框模式
                // pageMap.changeScienceMode();
            }
            
            const nextSubjectPanel = dm.getDataByTag(name + 'Page');
            const currentLeftPanel = this.currenSubsystemType === 'parkBuildingSubject' ? currentSubjectPanel.getChildAt(0).getChildAt(0) : currentSubjectPanel.getChildAt(0);
            const currentRightPanel = currentSubjectPanel.getChildAt(1);
            this.runSystemPanelAnim(currentLeftPanel, currentRightPanel, nextSubjectPanel.getChildAt(0), nextSubjectPanel.getChildAt(1), name + 'Page');

            if(this.currenSubsystemType === 'parkBuildingSubject' && pageMap.floorStatus === 'open') {
                pageMap.closeBuildingFloor(() => {
                   this.flyToSubsystem(name);
                });
            }
            else {
                this.flyToSubsystem(name);
            }
        }
        else {
            pageMap.setHTDaySceneVisible(true);
            pageMap.setHTNightSceneVisible(false);
            pageMap.closeNightSceneLight();
            pageMap.openDaySceneLight();

            // pageMap.switchDigitalTwinMode('day');
            // 关闭车流
            pageMap.stopCarFlowAnim();
            this.firstEnterNight = true;

            this.startMainPageAnim();
            const currentLeftPanel = currentSubjectPanel.getChildAt(0);
            const currentRightPanel = currentSubjectPanel.getChildAt(1);
            this.runSystemPanelAnim(currentLeftPanel, currentRightPanel, parkBuildingSubject.getChildAt(0).getChildAt(0), parkBuildingSubject.getChildAt(1), 'parkBuildingSubject');
        }
    }

    /**
     * 园区楼宇下的系统切换面板动画
     * @param {*} leftHidePanel 
     * @param {*} rightHidePanel 
     * @param {*} leftShowPanel 
     * @param {*} rightShowPanel 
     * @param {*} systemName 
     */
    runSystemPanelAnim(leftHidePanel, rightHidePanel, leftShowPanel, rightShowPanel, systemName) {
        if(this.pageLeftPanelAnims) {
            Object.values(this.pageLeftPanelAnims).forEach(lAnim => {
                lAnim.pause();
            });
        }
        if(this.pageRightPanelAnims) {
            Object.values(this.pageRightPanelAnims).forEach(rAnim => {
                rAnim.pause();
            });
        }
        this.pageLeftPanelAnims = {};
        this.pageRightPanelAnims = {};

        // 左侧
        leftHidePanel.eachChild((leftBlock,i) => {
            this.pageLeftPanelAnims[`leftHideAnim${i}`] = startAnim({
                delay: 100 * i,
                duration: 1500,
                easing: t => t,
                action: v => {
                    leftBlock.setScaleX(1 - v);
                    setBlockNodeOpacity(leftBlock, 1 - v);
                },
                finishFunc: () => {
                    leftBlock.s('2d.visible', false);
                    if(i === leftHidePanel.size() - 1) {
                        this.currenSubsystemType = systemName;
                        leftShowPanel.eachChild((leftBlock,j) => {
                            this.pageLeftPanelAnims[`leftShowAnim${j}`] = startAnim({
                                delay: 100 * j,
                                duration: 1500,
                                // easing: Easing.bounceIn,   
                                easing: t => t,
                                action: v => {
                                    leftBlock.s('2d.visible', true);
                                    leftBlock.setScaleX(v);
                                    setBlockNodeOpacity(leftBlock, v);
                                }
                            });
                        });
                    }
                }
            });
        });

        // 右侧
        rightHidePanel.eachChild((rightBlock,i) => {
            this.pageRightPanelAnims[`rightHideAnim${i}`] = startAnim({
                delay: 100 * i,
                duration: 1500,
                // easing: Easing.bounceIn,   
                easing: t => t,
                action: v => {
                    rightBlock.setScaleX(1 - v);
                    setBlockNodeOpacity(rightBlock, 1 - v);
                },
                finishFunc: () => {
                    rightBlock.s('2d.visible', false);
                    if(i === rightHidePanel.size() - 1) {
                        rightShowPanel.eachChild((rightBlock,j) => {
                            this.pageRightPanelAnims[`rightShowAnim${j}`] = startAnim({
                                delay: 100 * j,
                                duration: 1500,
                                // easing: Easing.bounceIn,   
                                easing: t => t,
                                action: v => {
                                    rightBlock.s('2d.visible', true);
                                    rightBlock.setScaleX(v);
                                    setBlockNodeOpacity(rightBlock, v);
                                }
                            });
                        });
                    }
                    if(i === rightHidePanel.getChildren().size() - 1) {            
                        this.runSwitchSubsystem = false;
                    }
                }
            });
        });
    }

    /**
     * 定位子系统的视角
     * @param {*} name
     */
    flyToSubsystem(name) {
        const pageMap = this.main.pageMap;
        const map = pageMap.map;

        ['elevatorSystem', 'lightSystem', 'fireFightingSystem', 'securitySystem', 'airConditioningSystem'].forEach(groupTag => {
            const group = map.dm.getDataByTag(groupTag);
            group.s('3d.visible', groupTag === name);
        })

        map.flyTo(SUBSYSTEM_CAMERA[name], () => { 
            // 电梯系统
            if(name === 'elevatorSystem') {
                // 开启电梯
                this.startElevatorSystemAnim();
                // 开启辅助电梯的运动
                // pageMap.startAnnexElevatorRunning();
            }
            else if(name === 'lightSystem') {
                this.startLightSystemAnim();
            }
            else if(name === 'fireFightingSystem') {
                this.startFireFightingSystemAnim();
            }
            else if(name === 'securitySystem') {
                const securitySystemFloor = this.main.g2d.dm().getDataByTag('SSF_L_1');
                securitySystemFloor.eachChild(node => {
                    node.a('isActive', false);
                });
            }
            else if(name === 'airConditioningSystem') {
                this.startPipeAnim();
            }
        });
    }

    /**
     * 开启首页的动画
     */
    startMainPageAnim() {
        this.stopMainPageAnim();
        
        const dm = this.dm;
        const subjectDatas = this.subjectDatas;
        const bsR1 = dm.getDataByTag('BS_R_1');
        const bsR2 = dm.getDataByTag('BS_R_2');

        // 开启园区信息的滚动
        const parkIntroduction = dm.getDataByTag('parkIntroduction');
        const textLines = parkIntroduction.a('ht.dataSource');
        const height = parkIntroduction.a('ht.rowHeight');
        const lineHeight = parkIntroduction.a('ht.rowLineWidth');
        const animOption = {
            duration: 2000,
            delay: 1000,
            easing: t => t,
            action: v => {
                parkIntroduction.a('ht.translateY', -(height + lineHeight) * v);
            },
            finishFunc: () => {
                textLines.push(textLines.shift());
                parkIntroduction.a('ht.translateY', 0);
                parkIntroduction.a('ht.dataSource', textLines);
                this.htAnims['bs_parkIntroductionAnim'] = startAnim(animOption);
            }
        };
        this.htAnims['bs_parkIntroductionAnim'] = startAnim(animOption);
        
        const r1Panel = bsR1.getChildAt(1);
        this.htAnims['bs_r1Anim1'] = startAnim({
            duration: 1500,
            easing: t => t,
            action: v => {
                r1Panel.a('clipPercentage1', v);
            }
        });
        this.htAnims['bs_r1Anim2'] = startAnim({
            delay: 800,
            duration: 1500,
            easing: t => t,
            action: v => {
                r1Panel.a('clipPercentage2', v);
            }
        });
        const energy = subjectDatas.energy;
        const scale = energy.energyRatio / 100;
        this.htAnims['bs_r1Anim3'] = startAnim({
            delay: 1600,
            duration: 3000,
            easing: t => t,
            action: v => {
                r1Panel.a({
                    energyRatio: parseInt(energy.energyRatio * v),
                    totalEnergy: parseInt(energy.totalEnergy * v),
                    totalLoad: parseInt(energy.totalLoad * v),
                    percentageValue: scale * v
                });
            }
        });

        let _oldpeople = [1664, 670, 854];
        let _newPeople = [1670, 685, 864];
        let _oldTotal = _oldpeople[0] + _oldpeople[1]+ _oldpeople[2];
        let _newTotal = _newPeople[0] + _newPeople[1]+ _newPeople[2];
        const staffNodeGroup = bsR2.getChildAt(2);
        const animOption2 = {
            delay: 3000,
            duration: 1500,
            easing: t => t,
            action: v => {
                let totalDs = 0;
                totalDs = _newTotal - _oldTotal;
                bsR2.getChildAt(1).a('totalPopulation', _oldTotal + parseInt(totalDs * v));
                staffNodeGroup.eachChild((node,i) => {
                    let ds = 0;
                    ds = _newPeople[i] - _oldpeople[i];
                    node.a('value', _oldpeople[i] + parseInt(ds * v));
                });
            },
            finishFunc: () => {
                staffNodeGroup.eachChild((node,i) => {
                    _oldpeople[i] = node.a('value');
                });
                _newPeople = [parseInt(random(1500, 1800)), parseInt(random(600, 750)), parseInt(random(800, 950))];
                _oldTotal = _oldpeople[0] + _oldpeople[1]+ _oldpeople[2];
                _newTotal = _newPeople[0] + _newPeople[1]+ _newPeople[2];
                this.htAnims['bs_updateDataAnim'] = startAnim(animOption2);
            }
        };
        this.htAnims['bs_updateDataAnim'] = startAnim(animOption2);
    }

    /**
     * 关闭首页动画
     */
    stopMainPageAnim() {
        ['bs_parkIntroductionAnim', 'bs_r1Anim1', 'bs_r1Anim2', 'bs_r1Anim3', 'bs_updateDataAnim'].forEach(name => {
            if(this.htAnims[name]) {
                this.htAnims[name].pause();
                this.htAnims[name] = null;
            }
        });
        this.dm.getDataByTag('parkIntroduction').a('ht.translateY', 0);
    }

    /**
     * 开启电梯系统动画
     */
    startElevatorSystemAnim() {
        const dm = this.dm;
        this.stopElevatorSystemAnim();

        this.htAnims['elevatorRunningAnim'] = startAnim({
            frames: Infinity,
            interval: 2000,
            action: () => {
                let num = parseInt(random(1, 5));
                let down = Math.random() > 0.5;
                let floorNumber = parseInt(random(1, 19));
                const rectNode = dm.getDataByTag(`floorRect${num}`);
                const floorIcon = dm.getDataByTag(`floorIcon${num}`);
                if (rectNode && floorIcon && !floorIcon.a('isAlarm') && !floorIcon.a('running')) {
                    floorIcon.a('running', true);
                    this._setFloor(floorIcon, rectNode, down, floorNumber, num);
                }
            }
        });

        // 2D 部分的动画
        const elevatorSystemRightPanel = dm.getDataByTag('elevatorSystemPage').getChildAt(1);
        const equipmentOperation = elevatorSystemRightPanel.getChildAt(1).getChildAt(1);
        let clipValue = 0;
        this.htAnims['elecatorPanelAnim'] = startAnim({
            interval: 20,
            frames: Infinity,
            action: () => {
                equipmentOperation.eachChild(node => {
                    clipValue += 0.01;
                    clipValue = clipValue > 1 ? 0 : clipValue;
                    node.a({
                        circleRotation: node.a('circleRotation') + Math.PI / 20,
                        clipValue: clipValue
                    })
                })
            }
        });
    }

    /**
     * 关闭电梯系统动画
     */
    stopElevatorSystemAnim() {
        ['elevatorRunningAnim', 'elecatorPanelAnim'].forEach(name => {
            if(this.htAnims[name]) {
                this.htAnims[name].pause();
                this.htAnims[name] = null;
            }
        });
    }

    /**
     * 设置楼层上升或下降
     * @param {*} node 
     * @param {*} rectNode 
     * @param {*} down 
     * @param {*} step 
     */
    _setFloor(node, rectNode, down, step = 1, floor) {
        const rect = rectNode.getRect();
        const oldFloor = parseInt(node.a('text'));
        let floorNum;
        if (down) {
            floorNum = oldFloor - step;
        } else {
            floorNum = oldFloor + step;
        }
        if (floorNum < 1 ) {
            floorNum = 1;
        };
        if (floorNum > 18 ) {
            floorNum = 17;
        };

        let y = rect.y + rect.height / 18 * (18 - floorNum);
        this._moveFloorTo(node, y, oldFloor, floorNum);
        this.main.pageMap.startMainElevatorRunning(floor, down, floorNum, oldFloor);
        node.a({
            down: down
        });
    }

    /**
     * 楼层移动动画
     * @param {*} node 
     * @param {*} targetY 
     * @param {*} startFloor 
     * @param {*} targetFloor 
     */
    _moveFloorTo(node, targetY, startFloor, targetFloor) {
        let startY = node.getY();
        startAnim({
            duration: Math.abs(targetFloor - startFloor) * 500,
            easing: Easing.easeOut,
            action: (v) => {
                node.setY(startY + (targetY - startY) * v);
                node.a({
                    text: startFloor + parseInt((targetFloor - startFloor) * v),
                });
                this.onElevatorMove(node, startFloor, targetFloor, v);
            },
            finishFunc: () => {
                node.a('running', false);
            }
        });
    }

    /**
     * 楼层移入触发事件
     * @param {*} elevator 
     * @param {*} start 
     * @param {*} target 
     * @param {*} v 
     */
    onElevatorMove(elevator, start, target, v) {

    }

    /**
     * 开启照明系统
     */
    startLightSystemAnim() {
        this.stopLightSystemAnim();

        const mapDm = this.main.pageMap.map.dm;
        const g2dDm = this.dm;
        const mainLighting = mapDm.getDataByTag('mainLighting');

        let index = 0;
        let show = true;
        let first = true;
        let floorStatus = [];

        const lightingAnimParam = {
            delay: 300,
            duration: 500,
            easing: t => t,
            action: v => {
                if(show !== floorStatus[index]) {
                    const light = mainLighting.getChildAt(index);
                    if(light) {
                        light.s('3d.visible', true);
                        light.eachChild((node,i) => {
                            let opacity = i === 0 ? 0.4 : i === 1 ? 0.14 : 0.5;
                            node.s('shape3d.opacity', show ? opacity * v : (1 - v) * opacity);
                        });
                    } 
                    floorStatus[index] = show;
                }
            },
            finishFunc: () => {
                if(index < mainLighting.getChildren().size() && first) {
                    index++;
                }
                else {
                    first = false;
                    index = parseInt(random(1, 18)) - 1;
                    show = Math.random() > 0.5;
                }
                this.htAnims['lightingAnim'] = startAnim(lightingAnimParam);
            }
        };

        this.htAnims['lightingAnim'] = startAnim(lightingAnimParam);

        // 2D 表单滚动
        const environmentWorkingTable = g2dDm.getDataByTag('environmentWorkingTable');
        const lightigRealAlarmTable = g2dDm.getDataByTag('lightigRealAlarmTable');
        this.htAnims['environmentWorkingTableAnim'] = runTableScrollAnim(environmentWorkingTable, {
            loop: true,
            dir: -1,
            // delay: 0,
            // duration: 3000
        }); 
        this.htAnims['lightigRealAlarmTableAnim'] = runTableScrollAnim(lightigRealAlarmTable, {
            loop: true,
            dir: -1,
            // delay: 0,
            // duration: 3000
        }); 
    }

    /**
     * 关闭照明系统
     */
    stopLightSystemAnim() {
        const mapDm = this.main.pageMap.map.dm;
        const mainLighting = mapDm.getDataByTag('mainLighting');
        mainLighting.eachChild(node => {
            node.s('3d.visible', false);
            node.eachChild(n => {
                n.s('shape3d.opacity', 0);
            });
        });

        ['lightingAnim', 'environmentWorkingTableAnim', 'lightigRealAlarmTableAnim'].forEach(name => {
            if(this.htAnims[name]) {
                this.htAnims[name].pause();
                this.htAnims[name] = null;
            }
        });  
    }
    
    /**
     * 开启消防系统动画
     */
    startFireFightingSystemAnim() {
        this.stopFireFightingSystemAnim();

        const mapDm = this.main.pageMap.map.dm;
        const g2dDm = this.dm;
        const fireFightingSystem = mapDm.getDataByTag('fireFightingSystem');
        fireFightingSystem.eachChild((node,i) => {
            node.a({
                opacity: 1,
                scale: 1
            });
        });

        const fireFightingAnimParam = {
            duration: 1000,
            easing: t => t,
            action: v => {
                fireFightingSystem.eachChild((node,i) => {
                    node.a({
                        opacity: 1 - v,
                        scale: 1 + v
                    });
                });
            },
            finishFunc: () => {
                this.htAnims['fireFightingAnim'] = startAnim(fireFightingAnimParam);
            }
        };

        this.htAnims['fireFightingAnim'] = startAnim(fireFightingAnimParam);

        // 2D table 动画
        const highRiskFireTable = g2dDm.getDataByTag('highRiskFireTable');
        const fireDetectorOperation = g2dDm.getDataByTag('fireDetectorOperation');
        const fireWaterPressure = g2dDm.getDataByTag('fireWaterPressure');

        this.htAnims['highRiskFireTableAnim'] = runTableScrollAnim(highRiskFireTable, {
            loop: true,
            dir: -1,
            // delay: 0,
            // duration: 3000
        }); 

        this.htAnims['fireDetectorOperationAnim'] = startAnim({
            interval: 20,
            frames: Infinity,
            action: () => {
                fireDetectorOperation.eachChild(block => {
                    block.eachChild(node => {
                        const circle1 = node.a('circle1') || 0;
                        const circle2 = node.a('circle2') || 0;
                        node.a({
                            circle1: circle1 + Math.PI / 90,
                            circle2: circle2 - Math.PI / 60
                        });
                    });
                });
            }
        });

        this.htAnims['fireWaterPressureAnim'] = startAnim({
            frames: Infinity,
            interval: 500,
            action: () => {
                const floorIndex = parseInt(random(1, 18)) - 1;
                const status = Math.random();
                const statusName = status > 0.4 ? (status > 0.8 ? '离线' : '异常') : '正常';
                const floor = fireWaterPressure.getChildAt(floorIndex);
                floor && floor.a('status', statusName);
            }
        });
    }

    /**
     * 关闭消防系统动画
     */
    stopFireFightingSystemAnim() {
        ['fireFightingAnim', 'highRiskFireTableAnim', 'fireDetectorOperationAnim', 'fireWaterPressureAnim'].forEach(name => {
            if(this.htAnims[name]) {
                this.htAnims[name].pause();
                this.htAnims[name] = null;
            }
        });
    }

    /**
     * 根据楼层号开启楼层安防设备
     * @param {*} number 
     */
    openSecuritySystemFloor(number) {
        const mapDm = this.main.pageMap.map.dm;
        const securitySystem = mapDm.getDataByTag('securitySystem');
        const floors = securitySystem.getChildAt(0);
        const equipments = securitySystem.getChildAt(1);

        if(number) {
            floors.eachChild((node,i) => {
                node.s('shape3d.opacity', (i === number - 1) ? 0.15 : 0);
                const equipment = equipments.getChildAt(i);
                equipment && equipment.s('3d.visible', i === number - 1);
            });
        }
        else {
            floors.eachChild(floor => {
                floor.s('shape3d.opacity', 0);
            });
            equipments.eachChild(equipment => {
                equipment.s('3d.visible', false);
            });
        }
    }

    /**
     * 开启管道动画
     */
    startPipeAnim() {
        // 3D 部分的动画
        const mapDm = this.main.pageMap.map.dm;
        const airConditioningSystem = mapDm.getDataByTag('airConditioningSystem');
        const outPipes = airConditioningSystem.getChildAt(0);
        const inPipes = airConditioningSystem.getChildAt(1);
        let inDir = true;
        let outDir = true;
        const airConditionInPipeParam = {
            duration: 2000,
            easing: t => t,
            action: v => {
                inPipes.eachChild(pipeGroup => {
                    pipeGroup.eachChild(pipe => {
                        pipe.s('3d.clip.percentage', v);
                    });
                });
            }
        };

        this.htAnims['airConditionInPipeAnim'] = startAnim(airConditionInPipeParam);
        const airConditionOutPipeParam = {
            delay: 2500,
            duration: 2000,
            easing: t => t,
            action: v => {
                outPipes.eachChild(pipeGroup => {
                    pipeGroup.eachChild(pipe => {
                        pipe.s('3d.clip.percentage', v);
                    });
                });
            }
        };

        this.htAnims['airConditionOutPipeAnim'] = startAnim(airConditionOutPipeParam);

        // 2D 部分的动画
        const dm = this.dm;
        const acsL1 = dm.getDataByTag('ACS_L_1');
        const acsL3 = dm.getDataByTag('ACS_L_3');
        
        const acsL1Panel = acsL1.getChildAt(1);
        const acsL1Progress = acsL1.getChildAt(2);
        let clipValue = 0;
        this.htAnims['acsL1Anim'] = startAnim({
            interval: 10,
            frames: Infinity,
            action: () => {
                clipValue += 0.01;
                clipValue = clipValue > 1 ? 0 : clipValue;
                acsL1Panel.a({
                    clipValue: clipValue
                });
            }
        });

        const acsL3Table = acsL3.getChildAt(2);
        this.htAnims['acsL3Anim'] = startAnim({
            interval: 2000,
            frames: Infinity,
            action: () => {
                const data = acsL3Table.a('ht.dataSource');
                const newData = data.map(value => {
                    return {
                        code: value.code,
                        temperature: parseFloat(random(25, 30)).toFixed(1),
                        humidity: parseInt(random(40, 60)),
                        TD: parseFloat(random(10, 20)).toFixed(1),
                        PPM: parseInt(random(20, 40))
                    }
                });
                acsL3Table.a('ht.dataSource', newData);

                const temperature = parseInt(random(25, 35));
                const humidity = Math.random();
                const windSpeed = parseFloat(random(1, 5)).toFixed(1);
                const pm25 = parseInt(random(30, 40));
                acsL1Panel.a({
                    temperature:  temperature,
                    humidity: parseInt(humidity * 100) + '%',
                    windSpeed: windSpeed + 'm/s'
                });
                [pm25, humidity, windSpeed / 5].forEach((value,i) => {
                    const node = acsL1Progress.getChildAt(i);
                    node && node.a('percentage', value);
                });
            }
        });
    }

    /**
     * 关闭管道动画
     */
    stopPipeAnim() {
        const mapDm = this.main.pageMap.map.dm;
        const airConditioningSystem = mapDm.getDataByTag('airConditioningSystem');
        const outPipes = airConditioningSystem.getChildAt(0);
        const inPipes = airConditioningSystem.getChildAt(1);
        [outPipes, inPipes].forEach(pipes => {
            pipes.eachChild(pipeGroup => {
                pipeGroup.eachChild(pipe => {
                    pipe.s({'3d.clip.percentage':0});
                });
            });
        });
        ['airConditionInPipeAnim', 'airConditionOutPipeAnim', 'acsL1Anim', 'acsL3Anim'].forEach(name => {
            if(this.htAnims[name]) {
                this.htAnims[name].pause();
                this.htAnims[name] = null;
            }
        });
    }
    
    /**
     * 重置所有页面
     */
     resetAllPage() {
        this.stopMainPageAnim();
        this.stopElevatorSystemAnim();
        this.stopLightSystemAnim();
        this.stopFireFightingSystemAnim();
        this.openSecuritySystemFloor();
        this.stopPipeAnim();
    }

    /**
     * 清除关闭所有动画及数据更新
     */
    clear() {
        const dm = this.dm;
        const pageMap = this.main.pageMap;

        if(this.pageLeftPanelAnims) {
            Object.values(this.pageLeftPanelAnims).forEach(lAnim => {
                lAnim.pause();
            });
        }
        if(this.pageRightPanelAnims) {
            Object.values(this.pageRightPanelAnims).forEach(rAnim => {
                rAnim.pause();
            });
        }
        this.pageLeftPanelAnims = {};
        this.pageRightPanelAnims = {};

        ['elevatorSystem', 'lightSystem', 'fireFightingSystem', 'securitySystem', 'airConditioningSystem'].forEach(tag => {
            const node = dm.getDataByTag(tag);
            if(node) {
                node.s('state', '默认');
                node.a('active', false);
            }
        });
        const parkBuildingSubject = dm.getDataByTag('parkBuildingSubject');
        const parkBuildingSubsystem = dm.getDataByTag('parkBuildingSubsystem');
        setBlockNodeOpacity(parkBuildingSubject, 1);
        parkBuildingSubject.getChildAt(0).getChildAt(0).eachChild(node => {
            node.s('2d.visible', true);
            node.setScaleX(1);
        });
        parkBuildingSubject.getChildAt(1).eachChild(node => {
            node.s('2d.visible', true);
            node.setScaleX(1);
        });
        parkBuildingSubsystem.eachChild(subsystem => {
            subsystem.eachChild(panel => {
                panel.eachChild(node => {
                    node.s('2d.visible', false);
                });
            })
        })

        pageMap.setHTDaySceneVisible(false);
        pageMap.setHTNightSceneVisible(false);
        pageMap.closeNightSceneLight();
        pageMap.closeDaySceneLight();

        this.currenSubsystemType = 'parkBuildingSubject';

        this.resetAllPage();

        // 关闭车流
        this.main.pageMap.stopCarFlowAnim();
    }
}